<div
  class="ticket-detail-header"
  [ngClass]="{ collapsed: isSideNavCollapsed || isSidenavClosed, expanded: !isSideNavCollapsed && !isSidenavClosed }"
>
  <button class="back-btn d-flex justify-content-center align-items-center" (click)="goBack()">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
  <h1 class="ml-3 mb-0 headline" data-testid="ticket-number-label">
    TICKET: <span class="detail-card__ticket-number" data-testid="ticket-number-value">{{ ticketNumber }}</span>
  </h1>
  @if (!isTicketClosed && canCloseTicket) {
    <div class="ticket-detail-header--close">
      <button mat-stroked-button type="button" class="ticket-detail-header--close-button" (click)="openCloseTicket()">
        <img src="../../../../../assets/svg/checkmark.svg" alt="Close ticket" class="close-icon" />
        <span class="button-text">Close</span>
      </button>
    </div>
  }
</div>
<div class="ticket-detail-body">
  <div class="left">
    <ticket-details-card
      service="managed-service"
      [ticketDetails]="ticketDetails"
      [isLoadingData]="isLoadingData"
      [isLoadingNotes]="isLoadingNotes"
      [isLoadingAttachments]="isLoadingAttachments"
      [statusMap]="statusMap"
      [ticketDetailService]="mspTicketDetailService"
      [ticketNotes]="ticketNotes"
    >
      <ticket-details-card-section id="details" name="Details" icon="icon_info">
        <msp-ticket-detail-card-details [ticket]="ticketDetails" [isLoadingData]="isLoadingData">
        </msp-ticket-detail-card-details>
      </ticket-details-card-section>
      <ticket-details-card-section id="notes" name="Notes" icon="icon_speaker-note">
        <div class="ticket-detail-card-notes">
          <ticket-notes
            [ticket]="ticketDetails"
            [ticketNotes]="ticketNotes"
            [isLoadingNotes]="isLoadingNotes"
            [apiTicketNotesFailed]="apiTicketNotesFailed"
            [ticketDetailService]="mspTicketDetailService"
            [repository]="managedServiceRepository"
            class="ticket-notes"
            [service]="'managed-service'"
          ></ticket-notes>
          <ticket-email-suscription
            [ticket]="ticketDetails"
            [isLoadingData]="isLoadingData"
            [repository]="managedServiceRepository"
            [ticketDetailService]="mspTicketDetailService"
            [automaticEmailCc]="ticketDetails?.automaticEmailCc"
            [apiTicketEmailNotificationsFailed]="false"
            (retryEmailNotifications)="fetchEmailNotifications()"
            class="ticket-email-suscription"
          ></ticket-email-suscription>
        </div>
      </ticket-details-card-section>
      <ticket-details-card-section id="attachments" name="Attachments" icon="icon_attachment">
        <ticket-attachments
          [repository]="managedServiceRepository"
          [ticketDetailService]="mspTicketDetailService"
          [ticketId]="ticketDetails?.id"
          [isLoading]="isLoadingAttachments"
          [apiTicketAttachmentsFailed]="apiTicketAttachmentsFailed"
        ></ticket-attachments>
      </ticket-details-card-section>
    </ticket-details-card>
  </div>
  @if (showApprovals() || showParentTicketCard() || showChildTicketsCard()) {
    <div class="right">
      @if (showApprovals()) {
        <ticket-detail-approvals-card
          class="right-card"
          [approvals]="approvals"
          [ticketDetails]="ticketDetails"
          [isApprovedOrDeniedExternally]="isApprovedOrDeniedExternally"
          [cwApprovedStatus]="cwApprovedStatus"
          [cwDeniedStatus]="cwDeniedStatus"
          (onUpdateApproval)="updateApproval($event)"
          [apiTicketApprovalsFailed]="apiTicketApprovalsFailed"
          [repository]="managedServiceRepository"
          [ticketDetailService]="mspTicketDetailService"
        >
        </ticket-detail-approvals-card>
      }
      @if (showParentTicketCard()) {
        <msp-ticket-detail-parent
          class="right-card"
          [ticketDetails]="ticketDetails"
          [parentTicketData]="parentTicketData"
          [isLoadingParentTicket]="isLoadingParentTicket"
          [statusMap]="statusMap"
          [apiParentTicketFailed]="apiParentTicketFailed"
        ></msp-ticket-detail-parent>
      }
      @if (showChildTicketsCard()) {
        <msp-ticket-detail-children
          class="right-card-flexible"
          [ticketDetails]="ticketDetails"
          [childTickets]="childTickets"
          [isLoadingChildTickets]="isLoadingChildTickets"
          [statusMap]="statusMap"
          [apiChildTicketsFailed]="apiChildTicketsFailed"
        >
        </msp-ticket-detail-children>
      }
    </div>
  }
</div>
